import { FC, useCallback, useState } from 'react';
import { Add as AddIcon } from '@mui/icons-material';
import { Button } from '@mui/material';
import NewCompanyDialog from 'layouts/Main/components/NewCompanyDialog';
import { FIRM_SUMMARY_ADD_COMPANY_TITLE } from 'pages/Firms/common/constants';

const AddCompanyButton: FC = () => {
  const [isNewCompanyDialogOpen, setIsNewCompanyDialogOpen] = useState(false);
  const handleOpenDialog = useCallback(() => setIsNewCompanyDialogOpen(true), []);
  const handleCloseDialog = useCallback(() => setIsNewCompanyDialogOpen(false), []);

  return (
    <>
      <Button
        color="primary"
        data-testid="firm-summary-add-company-button"
        endIcon={<AddIcon />}
        onClick={handleOpenDialog}
        variant="outlined">
        {FIRM_SUMMARY_ADD_COMPANY_TITLE}
      </Button>
      {isNewCompanyDialogOpen && (
        <NewCompanyDialog open={isNewCompanyDialogOpen} onClose={handleCloseDialog} />
      )}
    </>
  );
};

export default AddCompanyButton;
